import React, { useState, useRef, useEffect } from "react";
import { logisticTypes } from "../Router/constant";
import { updateBookingStatus } from "../Services/bookingService";
import ConfirmationModal from "../Components/ConfirmationModal";
import { toast } from 'react-toastify';
import { STATUS_OPTIONS, STATUS_MAPPING, RoutesPaths } from "../Router/constant";
import {
  uploadTransitSingleFile
} from "../Services/userService";
import { NavLink } from "react-router-dom";

export default function BookingDetails({ data = [], fetchBookings }) {
  const [activeProgress, setActiveProgress] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const fileInputRef = useRef(null);
  const [offset, setOffset] = useState(1);
  const limit = 5; // records per page
  const count = data.length; // total records
  const dropdownRef = useRef(null);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [confirmation, setConfirmation] = useState({
    show: false,
    orderId: null,
    statusValue: "",
  });
  const totalPages = Math.ceil(count / limit);
  const currentPage = offset;
  const toggleDropdown = (id) => {
    setActiveDropdown(activeDropdown === id ? null : id);
  };
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setConfirmation((prev) => ({
      ...prev,
      attachment: file,
    }));

    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await uploadTransitSingleFile(formData);

      console.log(response, "response");

      if (response?.data?.status === true) {
        const fileName = response.data.data.fileName;

        setConfirmation((prev) => ({
          ...prev,
          uploadedFileName: fileName,
        }));
      } else {
        toast.error("File upload failed");
      }

    } catch (error) {
      console.error("File upload error:", error);
      toast.error("File upload error");
    }
  };
  const handleStatusClick = (orderId, statusValue) => {

    setConfirmation({
      show: true,
      orderId,
      statusValue,
      customStatus: statusValue.toLowerCase() === "in transit" ? "" : null,
      messageText: statusValue.toLowerCase() === "in transit" ? "" : null
    });

    setActiveDropdown(null); // close dropdown
  };



  const handleConfirm = async () => {
    const { orderId, statusValue, customStatus, messageText } = confirmation;

    // Build payload
    let payload;
    if (statusValue.toLowerCase() === "in transit") {
      payload = {
        status: "in transit",
        customStatus: customStatus || "",
        inTransitMessage: messageText || "",
        attachment: confirmation.uploadedFileName || ""
      };
    } else {
      payload = { status: statusValue };
    }

    try {
      setConfirmLoading(true);
      const response = await updateBookingStatus(orderId, payload);

      if (response.data?.status === true) {
        toast.success(response?.data?.data?.message);
        setActiveDropdown(null);
        setConfirmation({ show: false, orderId: null, statusValue: "", customStatus: "", messageText: "", attachment: "" });

        if (typeof fetchBookings === "function") {
          await fetchBookings();
        }
      } else {
        toast.error(response?.data?.data?.message || "Failed to update order status.");
      }
    } catch (error) {
      toast.error(error?.response?.data?.data?.message || "An unexpected error occurred.");
    } finally {
      setConfirmLoading(false);
    }
  };

  const handleCancel = () => {
    setConfirmation({ show: false, orderId: null, statusValue: "" });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setActiveDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const generatePagination = (currentPage, totalPages) => {
    const pages = [];

    if (totalPages <= 4) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= 2) {
        pages.push(1, 2, '...', totalPages - 1, totalPages);
      } else if (currentPage <= 4) {
        pages.push(3, 4, '...', totalPages - 1, totalPages);
      } else if (currentPage >= totalPages - 2) {
        for (let i = totalPages - 2; i <= totalPages; i++) pages.push(i);
      } else {
        pages.push(currentPage, currentPage + 1, '...', totalPages - 1, totalPages);
      }
    }

    return pages;
  };
  const getRole = localStorage.getItem("userRole")

  const formatStatus = (status = '') => {
    const map = {
      'order placed': 'Order Placed',
      'submitted for quote': 'Submitted for Quote',
      'quote in place and sent to client for approval': 'Quote Sent to Client for Approval',
      'quote approved by client': 'Quote Approved by Client',
      'quote rejected by client': 'Quote Rejected by Client',
      'order accepted': 'Order Accepted',
      'product shipped': 'Product Shipped',
      'in transit': 'In-Transit',
      'in-transit': 'In-Transit',
      'delivered': 'Delivered',
    };

    return map[String(status).toLowerCase()] || status;
  };

  const formatStatusBadge = (status) => {
    const map = {
      pending: 'Pending',
      completed: 'Completed',
      inprogress: 'In-progress',
      'in progress': 'In-progress',

      'order placed': 'Order Placed',
      'submitted for quote': 'Submitted for Quote',
      'quote in place and sent to client for approval': 'Quote Sent to Client',
      'quote approved by client': 'Quote Approved',
      'quote rejected by client': 'Quote Rejected',

      'order accepted': 'Order Accepted',
      'product shipped': 'Product Shipped',
      'in-transit': 'In-Transit',
      'in transit': 'In-Transit',
      'delivered': 'Delivered',
    };

    return map[String(status).toLowerCase()] || status;
  };
  const formatLogisticsType = (type = '') =>
    type
      .toLowerCase()
      .replace(/_/g, ' ')
      .replace(/^./, char => char.toUpperCase());



  return (
    <div className="col-md-12 bookingDetailsMain">
      <div className="bookingDetailsOuter">
        <h6 className="bookingDetailsTitle">Booking details</h6>
        <div className="TableOverFlow">
          <div className="bookingContent bookingDetailsHeader">
            <div className="m-0 orderIdWidth">Booking id</div>
            <div className="m-0 userNameWidth">Customer name</div>
            <div className="m-0 logisticswidth">Service</div>
            <div className="m-0 statusWidth">Date</div>
            <div className="m-0 statusWidth">Order progress</div>
            <div className="m-0 statusWidth">Status</div>
            <div className="m-0 bookingActionwidth">Action</div>

          </div>

          {data.length === 0 ? (
            <p className="noOrders">No bookings found</p>
          ) : (
            data
              .slice((offset - 1) * limit, offset * limit)
              .map((item) => {
                return (
                  <div className="bookingContent bookingContentData" key={item._id}>
                    <div className="m-0 orderIdWidth">#{item.orderId}</div>
                    <div className="m-0 boldtext userNameWidth">{item.name}</div>
                    <div className="m-0 logisticswidth">
                      {formatLogisticsType(logisticTypes[item.logisticsType]) || "N/A"}
                    </div>
                    <div className="m-0 statusWidth">
                      {new Date(item.createdAt).toLocaleDateString()}
                    </div>
                    <div className="m-0 statusWidth orderProgress">
                      {(() => {
                        const progressList = [...new Set(
                          (item.orderHistory || [])
                            .filter(h => h.completed)
                            .map(h => {
                              if (h.status === 'product shipped') {
                                return 'in transit';
                              }
                              return h.status;
                            })
                        )].map(status => formatStatus(status));

                        if (progressList.length === 0) return "-";

                        const latest = progressList[progressList.length - 1];

                        return (
                          <>
                            {latest}
                            {progressList.length > 1 && (
                              <span
                                className="moreText clickable"
                                onClick={() => setActiveProgress(progressList)}
                              >
                                {" "}+{progressList.length - 1} more
                              </span>
                            )}
                          </>
                        );
                      })()}
                    </div>

                    <div className="m-0 statusWidth">
                      <span
                        className={`badgeBooking ${item.status.toLowerCase().replace(/\s+/g, '')}Badge`}
                      >
                        {formatStatusBadge(item.status)}
                      </span>
                    </div>

                    <div
                      className="m-0 bookingActionButtonsDash bookingActionwidth position-relative"
                      ref={activeDropdown === item._id ? dropdownRef : null}
                    >
                      <NavLink
                        to={`${RoutesPaths.BOOKINGMANAGEMENTORDERHISTORY}/${item?._id}`}
                        style={{ textDecoration: "none" }}
                      >
                        <p className="m-0">
                          <img src="/assets/img/view-filled.svg" alt=" " /> View
                        </p>
                      </NavLink>

                      <p
                        className={`m-0 ${getRole === 'partner' && !item?.isAccepted
                          ? 'disbaledEditBooking'
                          : ''
                          }`}
                        onClick={() => toggleDropdown(item._id)}
                      >
                        <img src="/assets/img/editgrey.svg" alt="" /> Edit
                      </p>

                      {activeDropdown === item._id && (
                        <div className="actionDropdownOuter">
                          <ul className="actionDropdownList">
                            {STATUS_OPTIONS.map((status) => {
                              const completedHistory = item.orderHistory?.filter(h => h.completed) || [];
                              const latestCompleted = completedHistory[completedHistory.length - 1]?.status.toLowerCase() || "";

                              return (
                                <li
                                  key={status}
                                  className={`actionDropdownItem ${latestCompleted === status.toLowerCase() ? "selected" : ""}`}
                                  onClick={() => handleStatusClick(item._id, status)}
                                >
                                  {status.toLowerCase() === "in transit"
                                    ? "Other"
                                    : status.charAt(0).toUpperCase() + status.slice(1)}
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      )}
                    </div>


                  </div>
                );
              })
          )}

        </div>
      </div>

      {activeProgress && (
        <div className="progressModalOverlay" onClick={() => setActiveProgress(null)}>
          <div
            className="progressModal"
            onClick={(e) => e.stopPropagation()}
          >
            <h4>Order Progress</h4>

            <ul>
              {activeProgress.map((step, i) => (
                <li key={i}>{step}</li>
              ))}
            </ul>

            <div className="modalFooter">
              <button
                className="btn btn-cancel"
                onClick={() => setActiveProgress(null)}
              >
                Close
              </button>
            </div>          </div>
        </div>
      )}

      {count > 0 && Math.ceil(count / limit) > 1 && (
        <div className="paginationSection">
          <p
            onClick={() => offset > 1 && setOffset(offset - 1)}
            style={{ opacity: offset > 1 ? 1 : 0.5, cursor: offset > 1 ? "pointer" : "default" }}
          >
            <img src="/assets/img/arrow-left.svg" alt="Previous" />
          </p>
          {generatePagination(currentPage, totalPages).map((page, idx) =>
            page === '...' ? (
              <p key={idx}>...</p>
            ) : (
              <p
                key={idx}
                onClick={() => setOffset(page)}
                style={{
                  fontWeight: currentPage === page ? 'bold' : 'normal',
                  cursor: 'pointer'
                }}
              >
                {page}
              </p>
            )
          )}



          <p
            onClick={() => offset < Math.ceil(count / limit) && setOffset(offset + 1)}
            style={{
              opacity: offset < Math.ceil(count / limit) ? 1 : 0.5,
              cursor: offset < Math.ceil(count / limit) ? "pointer" : "default"
            }}
          >
            <img src="/assets/img/arrow-right.svg" alt="Next" />
          </p>
        </div>
      )}


      <ConfirmationModal
        show={confirmation.show}
        title={
          confirmation.statusValue.toLowerCase() === "in transit"
            ? "Add custom tracking status"
            : "Update status"
        }
        message={
          confirmation.statusValue.toLowerCase() === "in transit" ? (
            <div>
              <p>Please enter a custom tracking status for the user to see:</p>
              <input
                type="text"
                placeholder="Custom tracking status"
                value={confirmation.customStatus || ""}
                onChange={(e) =>
                  setConfirmation({ ...confirmation, customStatus: e.target.value })
                }
                style={{ width: "100%", marginBottom: "8px", padding: "6px" }}
              />
              <textarea
                placeholder="Enter here message"
                value={confirmation.messageText || ""}
                onChange={(e) =>
                  setConfirmation({ ...confirmation, messageText: e.target.value })
                }
                style={{ width: "100%", padding: "6px" }}
              />
              <div
                style={{
                  border: "2px dashed #d1d5db",
                  borderRadius: "6px",
                  padding: "12px",
                  textAlign: "center",
                  background: "#fafafa",
                }}
              >
                <input
                  type="file"
                  id="attachmentUpload"
                  name="file"
                  ref={fileInputRef}
                  accept="image/*,application/pdf"
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />
                <label
                  htmlFor="attachmentUpload"
                  style={{
                    cursor: "pointer",
                    color: "#ff4d2d",
                    fontWeight: "500",
                  }}
                >
                  Click to upload file
                </label>

                <p style={{ fontSize: "12px", color: "#888", marginTop: "4px" }}>
                  PNG, JPG, PDF, DOC (Max 5MB)
                </p>
                {console.log(confirmation, 'confirmation')}
                {confirmation?.attachment && (
                  <div
                    style={{
                      marginTop: "8px",
                      padding: "6px 10px",
                      background: "#f1f5f9",
                      borderRadius: "4px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span style={{ fontSize: "13px" }}>
                      📎 {confirmation.attachment?.name}
                    </span>

                    <button
                      type="button"
                      onClick={() => {
                        setConfirmation((prev) => ({
                          ...prev,
                          attachment: null,
                        }));


                      }}
                      style={{
                        border: "none",
                        background: "transparent",
                        color: "red",
                        cursor: "pointer",
                      }}
                    >
                      Remove
                    </button>
                  </div>
                )}

              </div>
            </div>
          ) : (
            `Are you sure you want to update the status to "${confirmation.statusValue.replace(
              /\b\w/g,
              (char) => char.toUpperCase()
            )}"?`
          )
        }
        onConfirm={handleConfirm}
        onCancel={() =>
          setConfirmation({
            show: false,
            orderId: null,
            statusValue: "",
            customStatus: "",
            messageText: "",
            attachment: ""
          })
        }
        confirmText={confirmLoading ? "Confirming..." : (
          confirmation.statusValue.toLowerCase() === "in transit"
            ? "Save status"
            : "Confirm"
        )}
        confirmDisabled={confirmLoading}
        cancelText="Cancel"
      />


    </div>
  );
}
